var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.538 24.421l-10.334-11.81a2.526 2.526 0 113.803-3.327l11.789 13.473a2.526 2.526 0 010 3.328l-11.79 13.473a2.526 2.526 0 01-3.802-3.327l10.334-11.81z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PHBhdGggZD0iTTI2LjUzOCAyNC40MjFsLTEwLjMzNC0xMS44MWEyLjUyNiAyLjUyNiAwIDEgMSAzLjgwMy0zLjMyN2wxMS43ODkgMTMuNDczYTIuNTI2IDIuNTI2IDAgMCAxIDAgMy4zMjhsLTExLjc5IDEzLjQ3M2EyLjUyNiAyLjUyNiAwIDAgMS0zLjgwMi0zLjMyN2wxMC4zMzQtMTEuODF6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4K";
export { SvgChevron as ReactComponent };